const UserAdd = () => (
  <svg width="1em" height="1em" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M9.87694 11.5431C7.11182 11.591 5.01716 13.2552 4.15202 15.5944C3.81135 16.5155 4.59856 17.3753 5.58065 17.3753H10.4166M9.87694 11.5431C9.9178 11.5423 9.95881 11.542 9.99996 11.542C10.2934 11.542 10.5794 11.5601 10.8575 11.5952M9.87694 11.5431C9.33519 11.5525 8.81948 11.6239 8.33337 11.7503M10.8575 11.5952C11.1355 11.6303 11.4056 11.6823 11.6669 11.7503M10.8575 11.5952C11.4424 11.669 11.9919 11.818 12.5 12.032M15.2083 13.2087V15.7087M15.2083 15.7087V18.2087M15.2083 15.7087H12.7083M15.2083 15.7087H17.7083M13.125 5.91699C13.125 7.64288 11.7258 9.04199 9.99996 9.04199C8.27407 9.04199 6.87496 7.64288 6.87496 5.91699C6.87496 4.1911 8.27407 2.79199 9.99996 2.79199C11.7258 2.79199 13.125 4.1911 13.125 5.91699Z"
      stroke="#7A7A83"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default UserAdd
